<template>
    <main-content>
        <div class="shadow-sm bg-white rounded p-4">
            <transfer-form :form_data="form_data"
                           :password="password"
                           :form_meta_data="form_meta_data"
                           :on_submit="transfer"
            ></transfer-form>
        </div>
    </main-content>
</template>

<script>
    import TransferForm from './components/transfer-form'
    import mainContent from '@/components/main-content'
    import {i18n} from "@/plugins/i18n";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";

    export default {
        components: {
            TransferForm,
            mainContent,
        },
        data() {
            return {
                password: {
                    value: '',
                },
                form_data: [
                    {
                        amount: '',
                        destination_wallet_id: '',
                        transfer_description: ''
                    },
                ],
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.transfer'),
                },
            };
        },
        methods: {
            transfer() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        password: {
                            required: true,
                        },
                    },
                });

                if (! form.valid()) {
                    window.scrollTo({top: 1, behavior: 'smooth'});
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    transfers: this.form_data,
                    password: this.password.value,
                };

                walletService.transferAyande(params, this.$route.params.hashid).then(response => {
                    this.$router.push('/wallets');
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message);

                    if (response.data && response.data.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    window.scrollTo({top: 1, behavior: 'smooth'});
                }).finally(() => {
                        this.form_meta_data.submit_btn_progress = false;
                    }
                );
            },
        },
    }
</script>
